import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSmrtComponent } from './simple-icons-smrt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSmrtComponent ],
    exports:      [ SimpleIconsSmrtComponent ],
    bootstrap:    []
})
export class SimpleIconsSmrtModule {}
